export class ProductInfo {
  constructor(product_info) {
    this.id = product_info.id,
    this.name = product_info.name,
    this.type = product_info.type,
    this.description = product_info.description,
    this.image_url = product_info.image_url,
    this.price = product_info.price,
    this.status = product_info.status,
    this.created_at = product_info.created_at,
    this.updated_at = product_info.updated_at
  }
}
